import React, {useContext, useEffect, useState} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import {AppDataContext} from 'contexts/app-data'

import BaseParagraph from "../../base-components/base-paragraph";
import { useHistory } from 'react-router-dom';
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import getStep from '../../../helpers/getStep';


const FiscalResidence = ({_step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext}) => {

    const history = useHistory();
    //const handleClick = () => history.push('/legal-residence');
    const data = getDataFromContext(step_ID)
    const {state, dispatch} = useContext(AppDataContext)

    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [nextTick, setNextTick] = useState(false)

    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    const endFlow = () => {
        dispatch({
            type: 'SET_END_FLOW_MESSAGE',
            end_flow:{
                title:t('exit_messages.impossible_body_title'),
                description: t('exit_messages.fiscal_residence'),
                exit_statut: 3
                
            }
        })

        // history.push('/steps/end-flow')
    }

    useEffect(() => {
        if (inputData["fiscal_residence"] === 1) {
            setDataToContext(step_ID, step_URL, "fiscal_residence", 1)
            setNextTick(true)

        }
        if (inputData["fiscal_residence"] === 0) {
            setDataToContext(step_ID, step_URL, "fiscal_residence", 0)
            setNextTick(true)
        }
    }, [inputData])

    useEffect(() => {
        if (inputData["fiscal_residence"] === 1) {
            action()
        }
        if (inputData["fiscal_residence"] === 0) {
                       if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
eventType: "button click",
eventName: "fiscal residence not only BE",
trackMethod: "trackAction"
                    }
                );
            }
            endFlow()
            _step_service({step_ID, setIsLoading, next_step: '/steps/end-flow'})

        }
    }, [nextTick])
    
        const [savedData, setSavedData] = useState({})
        useEffect(() => {
        const asyncfunc = async () => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                    pageID: "onboarding",
                    stepSeq: "2",
                    stepName: "financial info:fiscal residence",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
                    }
                );
            }
            const serverData = await getStep(['fiscal_residence'])
            setSavedData({fiscal_residence: Number(serverData.fiscal_residence)})
        }
        asyncfunc()
     }, [])

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{ t('financial_infos.financial_info_fiscal_residence.title')}</h3>
                </BaseParagraph>

                <InputField type={"select"} name={"fiscal_residence"}
                    options={[
                        {value:1, label: t('general.yes')},
                        {value:0, label:t('general.no')}
                    ]}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && savedData[step_ID]}
                />

            </StepsLoader>
        </>
    )
}

FiscalResidence.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}




export default FiscalResidence